module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_32 (38).ade7535.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_32 (38).mp4
// module id = 813
// module chunks = 1